type AssignmentFormFile = {
  id: string;
  fileName: string;
  fileURL: string;
  contentType?: string;
  size?: number;
};

type AssignmentFormValues = {
  activityName: string;
  description?: string;
  videoUrl?: string;
  files?: AssignmentFormFile[];
  dueDate?: string | Date | null;
  enableFileUpload?: boolean;
  worksheetId?: string | null;
  activityState?: string;
  scheduledDate?: string | Date;
};

export const buildAssignmentActivityData = (data: AssignmentFormValues) => ({
  title: data.activityName,
  description: data.description,
  videoUrl: data.videoUrl || "",
  files: data.files || [],
  dueDate: data.dueDate ? data.dueDate : null,
  enableFileUpload: data.enableFileUpload,
  type: "Assignment",
  worksheetId: data.worksheetId,
  activityState: data.activityState,
  scheduledDate: data.scheduledDate,
});
